// src/polyfills/assert.browser.js

function fail(message) {
    // En dev on préfère voir l'erreur, en prod on peut ne rien faire
    if (process.env.NODE_ENV !== "production") {
        throw new Error(message || "Assertion failed");
    }
}

module.exports = {
    ok(value, message) {
        if (!value) fail(message);
    },
    equal(a, b, message) {
        if (a != b) fail(message);
    },
    strictEqual(a, b, message) {
        if (a !== b) fail(message);
    },
    // Ajoute d'autres méthodes si besoin plus tard
};